<template>
    <v-dialog v-model="dialog" width="800px">
        <v-form ref="assignLeadForm">
            <v-card>
                <v-card-title class="justify-center">Assign lead to an agent</v-card-title>
                <v-divider></v-divider>
                <v-row no-gutters class="mx-5">
                    <v-col cols=2>Lead</v-col> 
                    <v-col cols=10>{{ lead.pten_code }}</v-col> 
                </v-row>
                <v-row no-gutters class="mx-5" v-if="lead.pten_bedrijfsnaam!==''">
                    <v-col cols=2>Company</v-col> 
                    <v-col cols=10>{{ lead.pten_bedrijfsnaam }}</v-col> 
                </v-row>
                <v-row no-gutters class="mx-5">
                    <v-col cols=2>Name</v-col> 
                    <v-col cols=10>{{ lead.pten_voornaam }} {{ lead.pten_naam }}</v-col> 
                </v-row>
                <v-divider></v-divider>
                <v-row no-gutters class="mx-5 mt-5">
                    <v-col cols=4></v-col>
                    <v-col cols=4>
                        <v-select v-model="agent" :items="agents" item-value="gebr_code" item-text="gebr_naam" label="Assign an agent" clearable dense></v-select>
                    </v-col>
                    <v-col cols=4></v-col>
                </v-row>
                <v-divider></v-divider>
                <v-card-title class="justify-center" v-if="lead.pten_encrid!==''">Action for agent</v-card-title>
                <v-divider v-if="lead.pten_encrid!==''"></v-divider>
                <v-row no-gutters class="mx-4" v-if="lead.pten_encrid!==''">
                    <v-col cols="12">
                        <v-checkbox v-model="followUp.dontAddFollowUp" label="Do not add an action"></v-checkbox>
                    </v-col>
                </v-row>
                <v-row no-gutters class="mx-4" v-if="(!followUp.dontAddFollowUp)&&(lead.pten_encrid!=='')">
                    <v-col cols="6" class="pr-4">
                        <v-select v-model="followUp.patp_code" :clearable="true" :items="followUp.patp_codeKeuzes" item-value="patp_code" item-text="patp_oms" label="Type of action" dense></v-select>
                    </v-col>  
                    <v-col cols="6">
                        <date_picker label="Complete action before" :date="followUp.ptac_actie_dt" field="ptac_actie_dt" @updateData="updateData" dense/>
                    </v-col>
                </v-row>
                <v-row no-gutters class="mx-4" v-if="(!followUp.dontAddFollowUp)&&(lead.pten_encrid!=='')">
                    <v-col cols="12">
                        <v-textarea v-model="followUp.ptac_oms" rows="4" label="Action description" dense></v-textarea>
                    </v-col>
                </v-row>  
                <v-divider v-if="lead.pten_encrid!==''"></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" small @click="assignLead">Save & Close</v-btn>
                    <v-btn color="primary" small @click="closeLead">Close</v-btn>
                </v-card-actions>
            </v-card>
        </v-form> 
    </v-dialog>
</template>

<script>
    import date_picker from "@/components/ui/date_picker.vue";

    export default {
        components: {
            date_picker,
        },
        props: {
        },
        data() {
            return {
                dialog: false,
                agents: [],
                agent: "",
                lead: {},
                followUp: {},
            }
        },
        methods: { 
            open(lead, agents) {
                this.lead = lead;
                this.agent = lead.gebr_code;
                this.agents = agents;
                this.dialog = false;
                this.getPtenFollowUp();
            },
            getPtenFollowUp() {
                this.$axios.post("ares/json/ares/pten/getPtenFollowUp.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getPtenFollowUp",
                    },
                    getPtenFollowUp: {
                        pten_code: this.lead.pten_code
                    },
                }).then((res) => {
                    if (res.data.error) {
                        // console.log(res.data.error);
                        this.$store.dispatch("setSnackbar", {
                            showing: true,
                            text: res.data.error.message,
                            color: "error",
                        });
                    } else {
                        this.followUp = res.data.followUp;
                        this.followUp.patp_codeKeuzes = res.data.patp_codeKeuzes;
                        this.dialog = true;
                    }
                });

            },
            assignLead() {
                if (this.agent === "") {
                    this.$store.dispatch("setSnackbar", {
                        showing: true,
                        text: "No agent assigned!",
                        color: "warning",
                    }); 
                    return
                }
                if (this.lead.pten_encrid==='') {
                    this.$emit("actionClick", "setAgent", this.agent);
                    this.dialog = false;
                    return
                }
                this.followUp.ptac_actie_dt_ok = this.setDate(this.followUp.ptac_actie_dt);
                this.$axios.post("ares/json/ares/pten/setPtenAgent.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "setPtenAgent",
                    },
                    setPtenAgent: {
                        pten_encrid: this.lead.pten_encrid,
                        pten_gebr_code: this.agent,
                        followUp: this.followUp,
                    },
                }).then((res) => {
                    if (res.data.error) {
                        // console.log(res.data.error);
                        this.$store.dispatch("setSnackbar", {
                            showing: true,
                            text: res.data.error.message,
                            color: "error",
                        });
                    } else {
                        this.$store.dispatch("setSnackbar", {
                            showing: true,
                            text: res.data.setPtenAgent.text,
                            color: res.data.setPtenAgent.color,
                        });
                        this.$emit("actionClick", "refresh");
                        this.dialog = false;
                    }
                });
            },
            getDate(value) {
                if  (value === ""||value === null) {
                    return "";
                }
                if (value.substring(4, 5) === "-") {
                    return value.substring(8, 10) + "-" + value.substring(5, 7) + "-" + value.substring(0, 4); 
                }
                return value.substring(0, 10); 
            },
            setDate(date) {
                if (date.substring(2, 3) === "-") {
                    return date.substring(3, 5) + "-" + date.substring(0, 2) + "-" + date.substring(6, 10); 
                }
                return date.substring(8, 10) + "-" + date.substring(5, 7) + "-" + date.substring(0, 4); 
            },
            updateData(data) {
                this.followUp[data.field] = data.value;
            },
            closeLead() {
                this.dialog = false;
            },
        }
    }
</script>

